import { Address } from "cluster";
import { PaymentOption, NumberDoors, NumberLargeBags, NumberSeats, Location } from "../car-detail";
import { FeeOverrideData } from "../fee-override";
import { FlightInfo } from "../flight-info";
import { FeeTypes, FeeOverrideType } from "../models/fee-types";
import { ComputeTotalFromReservation } from "./reservation-total";

export interface Price {
  amount: number;
  currencyCode: string;
}

export interface ExpirationDate {
  year: string;
  month: string;
}

export interface Fee {
  type: FeeTypes;
  fee: Price;
  description: string;
}

export class DriverInformation {
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
  stateCode: string;
  phoneNumber: string;
  isOver25YearsOld: boolean;
}

export class CreditCardPayment {
  cardType: string;
  cardNumber: string;
  cardholderFirstName: string;
  cardholderLastName: string;
  cvv: string;
  expirationDate: ExpirationDate;
  country: string;
  countryCode: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
}

export class LoyaltyInfo {
  programId: string;
  membershipId: string;
}

export enum ArriviaReimbursmentPointsStatus {
  Failed = "failed",
  Completed = "completed",
  Pending = "pending"
}

export class AlternativeCurrency {
  constructor(
    public type: string,
    public conversionRate: number,
    public amount: Price,
    public pointsAmount?: number,
    public subtype?: string,
    public vendor?: string,
    public description?: string,
    public isRefundable?: boolean,
    public reimbursementPointsAmount?: number,
    public reimbursementConversionRate?: number,
    public reimbursementStatus?: ArriviaReimbursmentPointsStatus) {
  }
}

export class AlternativeMarginCurrency {
  constructor(
    public type: string,
    public conversionRate: number,
    public amount: Price,
    public creditsAmount?: Number,
    public description?: string,
    public isRefundable?: boolean) {
  }
}

export class FeeOverrideReservationData {
  constructor(type: FeeOverrideType, token: string) {
    this.type = type;
    this.token = token;
  }

  token: string;
  type: FeeOverrideType;
}

export class InsuranceCoverage {
  purchaseInsurance: boolean;
  price: number;
  offerId: string;
  quoteId: string;
}

export class ReservationRequest {

  constructor(currencyCode: string = 'USD') {
    this.correlationId = undefined;
    this.driverInformation = new DriverInformation();
    this.driverInformation.isOver25YearsOld = false;
    this.creditCardPayment = new CreditCardPayment();
    this.creditCardPayment.expirationDate
      = { year: undefined, month: undefined };
    this.loyaltyInfo = new LoyaltyInfo();
    this.flightInfo = new FlightInfo();
    this.bookingFees = [];
    this.alternativeCurrencies = [];
    this.alternativeCurrenciesFees = [];
    this.alternativeMarginCurrencies = [];
    this.feeOverrideTokens = [];
    this.paymentOptions = [];
    this.pointsSubType = undefined;
    this.outsideAgentId = undefined;
    this.totalAmount = { amount: 0, currencyCode: currencyCode };
    this.transactionId = undefined;
    this.insuranceCoverage = new InsuranceCoverage();
  }

  correlationId: string;
  vendorCode: string;
  rateCode: string;
  ratePlan: string;
  vehicleType: string;
  pickUpDate: string;
  pickUpTime: string;
  pickUpLocation: Location;
  returnDate: string;
  returnTime: string;
  returnLocation: Location;
  totalAmount: Price;
  alternativeCurrencies: AlternativeCurrency[];
  alternativeMarginCurrencies: AlternativeMarginCurrency[];
  bookingFees: Fee[];
  alternativeCurrenciesFees: Fee[];
  feeOverrideTokens: string[];
  driverInformation: DriverInformation;
  creditCardPayment: CreditCardPayment;
  paymentOptions: PaymentOption[];
  pointsSubType: string;
  loyaltyInfo: LoyaltyInfo;
  flightInfo: FlightInfo;
  locationCoordinate: string;
  hash: string;
  areTermsAndConditionsAccepted: boolean;
  outsideAgentId: string;


  programName: string;
  transactionId: string;
  rateKey: string;
  netRateKey: string;
  bookingKey: string;
  imageUrl: string;
  carModelName: string;
  companyLogoUrl: string;
  companyName: string;
  numberDoors: NumberDoors;
  numberLargeBags: NumberLargeBags;
  numberSeats: NumberSeats;
  insuranceCoverage: InsuranceCoverage;
}

export class Reservation extends ReservationRequest {

  constructor(currencyCode: string = 'USD'
  ) {
    super(currencyCode);
    this.feeOverrides = [
      new FeeOverrideData(
        FeeOverrideType.AgentFeeOverride, null, 0),
      new FeeOverrideData(
        FeeOverrideType.ProcessingPointsFeeOverride, null, 0),
      new FeeOverrideData(
        FeeOverrideType.PartnerAgentFeeOverride, null, 0),
    ];
    this.loyaltyInfo = new LoyaltyInfo();
  }

  public feeOverrides: FeeOverrideData[];

  public getTotal(): Price {
    return ComputeTotalFromReservation(this);
  }
}

export class ReservationResponse {
  bookingId: string;
}
